export const setAttribute = () => {
	const addNoopener = (a) => {
		if (a.tagName === 'A' && a.target === '_blank') {
			const rel = new Set(
				(a.getAttribute('rel') || '').split(/\s+/).filter(Boolean)
			);
			rel.add('noopener');
			rel.add('noreferrer');
			a.setAttribute('rel', Array.from(rel).join(' '));
		}
	};

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((m) => {
			m.addedNodes &&
				m.addedNodes.forEach((node) => {
					if (node.nodeType !== 1) return;
					if (node.matches && node.matches('a[target="_blank"]')) {
						addNoopener(node);
					}
					node.querySelectorAll &&
						node
							.querySelectorAll('a[target="_blank"]')
							.forEach(addNoopener);
				});
		});
	});

	observer.observe(document.documentElement || document.body, {
		childList: true,
		subtree: true,
	});

	document.querySelectorAll('a[target="_blank"]').forEach((a) => {
		addNoopener(a);
	});
};
